import { useQueryClient, useMutation } from "@tanstack/react-query";
import { notificacionError, notificacion } from "../../../../components/Alerts";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import type { Usuario, Respuesta } from "../../../../ts/typings/clases";
import { ModalConfirmar } from "../../../../components/modals/Confirmar";

interface ModalEliminarUsuarioProps {
	readonly show: boolean;
	readonly close: () => void;
	readonly usuario: Usuario | null;
}
export function ModalEliminarUsuario(props: ModalEliminarUsuarioProps) {
	const queryClient = useQueryClient();

	const mutationDelete = useMutation({
		mutationFn: (idUsuario: string | undefined) => {
			if (!idUsuario) {
				return Promise.resolve({ tipo: "error", message: "ID de usuario no válido." } as Respuesta);
			}
			return ComunicacionAjax.sendAjaxRequest<Respuesta>("POST", "/api/v1/eliminarusuario", {
				"id": idUsuario,
			});
		},
		onSuccess: async (data) => {
			if (data.tipo != "exito") {
				notificacionError(data.message ?? "Error eliminando el usuario.");
				return;
			}

			notificacion(data.message ?? "Usuario eliminado correctamente.");
			props.close();
			await queryClient.invalidateQueries({ queryKey: ["getListadoUsuarios"] });
		}
	});

	return (
		<ModalConfirmar
			title="Eliminar Usuario"
			message="¿Desea eliminar el usuario?"
			onConfirm={() => mutationDelete.mutate(props.usuario?.id)}

			show={props.show}
			close={props.close}

			confirmText="Eliminar"
			cancelText="Cerrar"
		/>
	);
}